import { z } from 'zod';
import { SyncableEntitySchema } from './entity';

export const TopicStatusSchema = z.enum(['NOT_STARTED', 'IN_PROGRESS', 'COMPLETED']);
export type TopicStatus = z.infer<typeof TopicStatusSchema>;

export const SyllabusUnitSchema = SyncableEntitySchema.extend({
  subjectId: z.string().uuid(),
  unitNumber: z.number().int().positive(),
  title: z.string().min(1),
  status: TopicStatusSchema.default('NOT_STARTED'),
  sortOrder: z.number().int().default(0),
});
export type SyllabusUnit = z.infer<typeof SyllabusUnitSchema>;

export const ChapterSchema = SyncableEntitySchema.extend({
  unitId: z.string().uuid(),
  chapterNumber: z.number().int().positive(),
  title: z.string().min(1),
  sortOrder: z.number().int().default(0),
});
export type Chapter = z.infer<typeof ChapterSchema>;

export const TopicSchema = SyncableEntitySchema.extend({
  chapterId: z.string().uuid(),
  topicNumber: z.number().int().positive(),
  title: z.string().min(1),
  status: TopicStatusSchema.default('NOT_STARTED'),
  masteryScore: z.number().min(0).max(100).default(0),
  notes: z.string().default(''),
  sortOrder: z.number().int().default(0),
});
export type Topic = z.infer<typeof TopicSchema>;

export const PaperTopicLinkSchema = SyncableEntitySchema.extend({
  pastPaperId: z.string().uuid(),
  topicId: z.string().uuid(),
  questionReference: z.string().default(''),
});
export type PaperTopicLink = z.infer<typeof PaperTopicLinkSchema>;
